<template>
  <b-modal
    v-model="showModal"
    size="xl"
    title-class="font-18"
    title="Limites das Normas"
    hide-footer
  >
    <div class="row">
      <div class="col-md-3">
        <label>Norma</label>
      </div>
      <div class="col-md-2">
        <label>Tipo de Limite</label>
      </div>
      <div class="col-md-1">
        <label>Valor Limite</label>
      </div>
      <div class="col-md-2 text-center">
        <label>Bloqueia Excesso</label>
      </div>
      <div class="col-md-2 text-center">
        <label>Bloqueia Excesso RDV</label>
      </div>
      <div class="col-md-2 text-center">
        <label>Bloqueia Cidade Sede</label>
      </div>
    </div>

    <div class="accordion" role="tablist">
      <b-card
        v-for="(norma, index) in normas"
        :key="index"
        no-body
        class="mb-1"
      >
        <b-card-header header-tag="header" class="p-1" role="tab">
          <div
            class="row div-clickable"
            block
            @click="abreFechaCollapse(index)"
          >
            <div class="col-md-3 d-flex">
              <strong class="mt-1"> {{ norma.ds_norma }} </strong>
              <strong>
                <i v-if="ref == index" class="bx bx-chevron-up fs-2" />
                <i v-else class="bx bx-chevron-down fs-2" />
              </strong>
            </div>
            <div class="col-md-2">
              <label>{{ norma.ds_tp_limite }}</label>
            </div>
            <div class="col-md-1">
              <label>{{ $tools.converteReal(norma.vl_limite) }}</label>
            </div>
            <div class="col-md-2 text-center">
              <label
                class="badge badge-pill font-size-14"
                :style="'background:' + validaBloqueio(norma.bloq_rdv).color"
              >
                {{ validaBloqueio(norma.bloq_rdv).value }}
              </label>
            </div>
            <div class="col-md-2 text-center">
              <label
                class="badge badge-pill font-size-14 ms-4"
                :style="
                  'background:' + validaBloqueio(norma.bloq_despesa).color
                "
              >
                {{ validaBloqueio(norma.bloq_despesa).value }}
              </label>
            </div>
            <div class="col-md-2 text-center">
              <label
                class="badge badge-pill font-size-14 ms-4"
                :style="
                  'background:' + validaBloqueio(norma.bloq_cidade_sede).color
                "
              >
                {{ validaBloqueio(norma.bloq_cidade_sede).value }}
              </label>
            </div>
          </div>
        </b-card-header>
        <b-collapse :visible="ref == index">
          <b-card-body>
            <b-card-text>{{ norma.ds_obs }}</b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
      normas: [],
      cdProjeto: null,
      ref: -1,
    };
  },
  computed: {},

  methods: {
    abreFechaCollapse(index) {
      if (index == this.ref) {
        this.ref = -1;
      } else {
        this.ref = index;
      }
    },
    abrirModal(cdProjeto) {
      this.showModal = true;
      this.cdProjeto = cdProjeto;
      this.buscarNormas();
    },
    async buscarNormas() {
      this.normas = await this.$tools.filtroCooperado.buscarLimitesNormas(
        this.cdProjeto
      );
    },
    validaBloqueio(param) {
      return param == "S"
        ? { value: "SIM", color: "green" }
        : { value: "NÃO", color: "tomato" };
    },
  },
};
</script>
<style>
</style>